<form [formGroup]="signalIssueForm">
    <app-page-stepper [verticalSteps]="false"
                      (stepChange)="onStepChange($event)"
                      (submit)="signalIssue()" (tryNext)="onTryNext()"
                      [isLoading]="isLoading">
        <app-stepper [canContinue]="isLineSelected">
            <ng-template #title>{{ 'lineSetter.signalIssue.stepTitles.selectLine' | translate }}</ng-template>
            <ng-template #content
                         let-step="step">
                <div class="ls-signal-issue">
                    <h5>{{ "lineSetter.signalIssue.form.selectManufacturingLine" | translate }}</h5>
                    <div class="ls-issue-main-data">
                        <div class="issue-input-container">
                            <label [ngClass]="{'error': !isLineSelected && firstNextTried}" for="manufacturing-line">
                                {{ 'lineSetter.signalIssue.form.line.label' | translate }}
                            </label>
                            <app-dropdown-autocomplete id="manufacturing-line"
                                                       formControlName="lineId"
                                                       [formControl]="signalIssueForm.controls['lineId']"
                                                       [showErrors]="step.nextTriggered"
                                                       [items]="lines"
                                                       valueField="id"
                                                       displayField="name"
                                                       [emptyText]="'lineSetter.signalIssue.form.line.placeholder' | translate"
                                                       (selectItem)="onLineChange($event)">
                            </app-dropdown-autocomplete>
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-stepper>
        <app-stepper [canContinue]="isToolScanned">
            <ng-template #title>{{ 'lineSetter.signalIssue.stepTitles.scanTool' | translate }}</ng-template>
            <ng-template #content
                         let-step="step">
                <form class="tool-scan-step" [formGroup]="selectToolsForm">
                    <app-tool-scan-tree labelText="{{'admin.tickets.create-modal.issueToolScan.title' | translate}}"
                                        emptyMessage="{{'tree.toolSelect.emptyMessage' | translate}}"
                                        class="toolScanner"
                                        formControlName="selectedTools"
                                        [mode]="'scan'"
                                        [isMaterial]="false"
                                        [formControl]="selectToolsForm.controls['selectedTools']"
                                        [showErrors]="step.nextTriggered"
                                        [items]="selectedTools"
                                        [onlyOne]="true">
                    </app-tool-scan-tree>
                </form>
            </ng-template>
        </app-stepper>
        <app-stepper [canContinue]="isFormValid">
            <ng-template #title>{{ 'lineSetter.signalIssue.stepTitles.issueDetails' | translate }}</ng-template>
            <ng-template #content
                         let-step="step">
                <div>
                    <div class="row">
                        <div class="col s12">
                            <app-dropdown-autocomplete formControlName="reasonId"
                                                       [formControl]="signalIssueForm.controls['reasonId']"
                                                       [showErrors]="step.nextTriggered"
                                                       [items]="reasons"
                                                       valueField="id"
                                                       displayField="name"
                                                       [label]="'lineSetter.signalIssue.form.reason.label' | translate"
                                                       [emptyText]="'lineSetter.signalIssue.form.reason.placeholder' | translate"
                                                       (selectItem)="onReasonChange($event)">
                            </app-dropdown-autocomplete>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <app-textarea [formControl]="signalIssueForm.controls['description']"
                                          [(ngModel)]="issue.description"
                                          [showErrors]="step.nextTriggered"
                                          [maxLength]="120"
                                          [label]="'lineSetter.signalIssue.form.description.label' | translate"
                                          [placeholder]="'lineSetter.signalIssue.form.description.placeholder' | translate">
                            </app-textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <app-tooltip *ngIf="isDisable"
                                         type="info"
                                         [tooltipPosition]="'right'"
                                         [record]="'lineSetter.signalIssue.form.isReplacementOrdered.tooltip' | translate">
                            </app-tooltip>
                            <app-input-switch formControlName="isReplacementOrdered"
                                              [(ngModel)]="issue.isReplacementOrdered"
                                              style="padding-top: 50px;"
                                              [disabled]=isDisable
                                              [onLabel]="'lineSetter.signalIssue.form.isReplacementOrdered.onLabel' | translate"
                                              [offLabel]="'lineSetter.signalIssue.form.isReplacementOrdered.offLabel' | translate"
                                              [topLabel]="'lineSetter.signalIssue.form.isReplacementOrdered.topLabel' | translate">
                            </app-input-switch>
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-stepper>
    </app-page-stepper>
</form>
